import { buildModelManager } from "../builder.js";
const DefaultEmailLogSelection = {
  __typename: true,
  id: true,
  clickCount: true,
  clickedAt: true,
  createdAt: true,
  deliveredAt: true,
  email: true,
  failureType: true,
  listUnsubscribedAt: true,
  messageId: true,
  openCount: true,
  openedAt: true,
  provider: true,
  sentAt: true,
  shopId: true,
  status: true,
  template: true,
  updatedAt: true
};
const modelApiIdentifier = "emailLog";
const pluralModelApiIdentifier = "emailLogs";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailLogSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEmailLog",
    operationReturnType: "CreateEmailLog",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { emailLog: { required: false, type: "CreateEmailLogInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailLogSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEmailLogs",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateEmailLogsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailLogSelection
  },
  {
    type: "action",
    operationName: "updateEmailLog",
    operationReturnType: "UpdateEmailLog",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      emailLog: { required: false, type: "UpdateEmailLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailLogSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateEmailLogs",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateEmailLogsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailLogSelection
  },
  {
    type: "action",
    operationName: "upsertEmailLog",
    operationReturnType: "UpsertEmailLog",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      emailLog: { required: false, type: "UpsertEmailLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateEmailLogResult": { hasReturnType: false },
      "... on UpdateEmailLogResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailLogSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertEmailLogs",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertEmailLogsInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultEmailLogSelection
  }
];
const EmailLogManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEmailLogSelection,
  operations
);
export {
  DefaultEmailLogSelection,
  EmailLogManager
};
//# sourceMappingURL=EmailLog.js.map
